import React, {useCallback, useEffect, useState} from "react";
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import "react-toastify/dist/ReactToastify.css";
import Button from "react-bootstrap/Button";
import RightModal from "./modalForm";

import { useRedux, useHistory, useSearchInput } from "../../../hooks";

import {
    editDataSaleDeliverySystem, getSaleDeliverySystems,
    onRemoveSaleDeliverySystem,
    removeSaleDeliverySystemModalHide,
    removeSaleDeliverySystemModalShow,
    showRightModalSaleDeliverySystem
} from "../../../redux/actions";

import TableList from "../../../components/TableList";
import SaleDeliverySystemColumns from "./tableColumns";
import {DeliverySystemType} from "../../../redux/Sale/DeliverySystem/types";
import {EntityActionsHandlersType} from "../../../redux/types";
import RemoveModal from "../../../components/RemoveForm";

import '../../../i18/config';
import {useTranslation} from "react-i18next";
import BreadCrumb from "../../../components/Common/BreadCrumb";
import Loader from "../../../components/Loader";
import MainListFilter from "../../../components/MainListFilter";

const SaleDeliverySystemIndex = () => {
    const { dispatch, useAppSelector } = useRedux();

    const { t } = useTranslation(['common']);

    const componentType = 'saleDeliverySystemTable';

    const {
        historyHash,
        searchPhrase,
        loadItems,
        handleSearchClick
    } = useHistory({
        componentType,
        loadAction: getSaleDeliverySystems,
        dispatch
    });

    const { onSearchInput } = useSearchInput(handleSearchClick);

    const {
        saleDeliverySystem,
        isFetched
    } = useAppSelector(state => ({
        saleDeliverySystem: state.SaleDeliverySystem,
        isFetched: state.SaleDeliverySystem.isFetched
    }));

    const openRightModal = useCallback((event:any) => {
        if ((event !== undefined) && (event.uuid !== undefined) && (event.uuid.length>0)){
            dispatch(editDataSaleDeliverySystem({data:event, modalEditTitle: 'changeDeliveryService'}));
        } else {
            dispatch(showRightModalSaleDeliverySystem({data:[], modalEditTitle: 'newDeliveryService'}));
        }
    }, [dispatch]);

    const onEntityRemoveModalShow = useCallback((event:any) => {
        if ((event !== undefined) && (event.uuid !== undefined) && (event.uuid.length>0)){
            dispatch(removeSaleDeliverySystemModalShow({data:event, modalEditTitle: 'deleteDeliveryService'}));
        }
    },[dispatch]);

    const onEntityRemoveModalHide = useCallback(() => dispatch(removeSaleDeliverySystemModalHide()),[dispatch]);

    const onEntityRemove = useCallback((event:any) => {
        if ((event !== undefined) && (event.uuid !== undefined) && (event.uuid.length>0)){
            dispatch(onRemoveSaleDeliverySystem({data:event, modalEditTitle: 'deleteDeliveryService'}));
        }
    },[dispatch]);

    useEffect(() => {
        if(saleDeliverySystem.isNeedReload){
            loadItems();
        }
    }, [saleDeliverySystem.isNeedReload, loadItems]);

    const EntityActionsHandlers:EntityActionsHandlersType = {
        onEdit: openRightModal,
        onRemove: onEntityRemoveModalShow
    }

    const onTableRowClick = useCallback((item:DeliverySystemType) => {
        if (item.actions && item.actions.canEdit){
            openRightModal(item);
        }
    },[openRightModal]);

    const columns = SaleDeliverySystemColumns(EntityActionsHandlers);

    return (
        <>
            <BreadCrumb title={t('menu:deliverySystems')} pageTitle={t('menu:main')} />
                <Row className="g-4 mb-3">
                    <div className="col-sm-auto">
                        <div>
                            <Button variant="secondary" onClick={openRightModal} className="btn btn-success">
                                <i className="ri-add-line align-bottom me-1"/> {t('common:addNew')}
                            </Button>
                        </div>
                    </div>
                </Row>

                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardHeader className="border-bottom-0">
                                <h5 className="card-title mb-0">{t('delivery:deliveryServices')}</h5>
                            </CardHeader>
                            <CardBody className="border border-dashed border-end-0 border-start-0 pb-3">
                                <MainListFilter
                                    onClick={handleSearchClick}
                                    value={searchPhrase}
                                    onChange={onSearchInput}
                                />
                            </CardBody>
                            <CardBody>
                                {isFetched ?
                                    <TableList
                                    columns={columns}
                                    data={saleDeliverySystem.items}
                                    onRowClick={onTableRowClick}
                                    key={componentType}
                                    historyHash = {historyHash}
                                    paginationTotalRows={saleDeliverySystem?.meta?.totalCount || 0}
                                    paginationServer={true}
                                    isShowChangePageSize={true}
                                    />
                                    :
                                    <Loader/>
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <RightModal/>
                <RemoveModal
                    onRemove={onEntityRemove}
                    handleClose={onEntityRemoveModalHide}
                    removeItem={saleDeliverySystem.selectedItem}
                    isOpen={saleDeliverySystem.removeModalShow}
                    modalTitle={saleDeliverySystem.modalEditTitle}/>
        </>
    );
};

export default SaleDeliverySystemIndex;


